import {serializeError} from 'serialize-error';
export type response = {data?: any, error?:boolean,errorDetails?:any}
const logPrefix = "[FetchResourcesService]"
export async function fetchResources (resource:string):Promise<response>{
    const abortController = new AbortController();
      const fetchData = async () => {
        console.log(logPrefix,"fetching:", resource);
        let fetchResult  = null;
        try { 
         // console.group(logPrefix);
          const fetchResponse = await fetch(resource, {
            signal: abortController.signal,
          });
          if(fetchResponse.headers.get('Content-Type')?.includes('application/json')){
            //console.log(logPrefix,"valid json",resource)
            //console.log(logPrefix,{resource},{fetchResponse});
           const fetchJson = await fetchResponse.json();
           //console.log(logPrefix,{resource},{fetchJson});
           fetchResult= {data: fetchJson}
          }
          else {
            console.warn(logPrefix,"invalid json",resource,fetchResponse.headers.get('Content-Type'));
            fetchResult= {error:true, errorDetails: `Unexpected format ${fetchResponse.headers.get('Content-Type')}`}
          }
          
        } catch (error:any) {
            const fetchError = serializeError(error);
            console.error(logPrefix,{resource},{fetchError});
            fetchResult= {error:true, errorDetails: serializeError(fetchError)}
        }  
        return fetchResult;
      };
    const response = await fetchData();
    return response
     
}